// extracted by mini-css-extract-plugin
export var table = "_y0-0";